<div class="form-group row">
    <div class="col-8">
        <ng-content select=".title"></ng-content>
    </div>
    <div class="col-4" style="padding-right: 0;">
        <div class="form-check form-check-inline">
            <ng-content select=".radioTrue"></ng-content>
            <ng-content select=".labelTrue"></ng-content>
        </div>
        <div class="form-check form-check-inline">
            <ng-content select=".radioFalse"></ng-content>
            <ng-content select=".labelFalse"></ng-content>
        </div>
    </div>
</div>
